import { Link } from '@tanstack/react-router';
import { ChevronDown, Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { CategoryRow } from '@/server/functions/admin';

const menuItemClass =
    'cursor-pointer rounded-none px-3 py-2 text-[13px] text-white/75 focus:bg-white/[0.06] focus:text-white';

export function NewArticleButton({
    categories,
    trigger,
}: {
    categories: (Pick<CategoryRow, 'id' | 'name'> & { archived?: boolean })[];
    trigger?: React.ReactNode;
}) {
    const activeCategories = categories.filter((category) => !category.archived);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                {trigger ?? (
                    <Button size="sm" className="rounded-none">
                        <Plus className="size-3.5" />
                        <span className="sm:hidden">חדשה</span>
                        <span className="hidden sm:inline">כתבה חדשה</span>
                        <ChevronDown className="size-3.5 opacity-70" />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="start"
                sideOffset={8}
                className="min-w-48 rounded-none border-white/12 bg-black p-1 text-[#ededed] shadow-none"
            >
                <DropdownMenuLabel className="px-3 py-2 text-[11px] font-normal text-white/40">
                    בחירת קטגוריה
                </DropdownMenuLabel>
                <DropdownMenuSeparator className="bg-white/10" />
                {activeCategories.length === 0 ? (
                    <DropdownMenuItem asChild className={menuItemClass}>
                        <Link
                            to="/admin/articles/$id"
                            params={{ id: 'new' }}
                        >
                            ללא קטגוריה
                        </Link>
                    </DropdownMenuItem>
                ) : (
                    activeCategories.map((category) => (
                        <DropdownMenuItem
                            key={category.id}
                            asChild
                            className={menuItemClass}
                        >
                            <Link
                                to="/admin/articles/$id"
                                params={{ id: 'new' }}
                                search={{ category: category.id }}
                            >
                                {category.name}
                            </Link>
                        </DropdownMenuItem>
                    ))
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
